import { render, staticRenderFns } from "./Region3.vue?vue&type=template&id=39cb431a&scoped=true&"
import script from "./Region3.vue?vue&type=script&lang=ts&"
export * from "./Region3.vue?vue&type=script&lang=ts&"
import style0 from "./Region3.vue?vue&type=style&index=0&id=39cb431a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb431a",
  null
  
)

export default component.exports